// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/c6afee1e283765a29b6a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"97804137e0fd19bf47df","127":"1dff6a5713fa16e9cc4d","128":"458d79e6c5ead65572b5"}[chunkId] + ".chunk.js";
};